import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const DeepRutsIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Deep ruts - parallel grooves in ground */}
    <path d="M3 8v8c0 1 1 2 2 2h14c1 0 2-1 2-2V8" />
    <path d="M6 8v7" />
    <path d="M10 8v7" />
    <path d="M14 8v7" />
    <path d="M18 8v7" />
    <path d="M3 8h18" />
  </svg>
);
